module.exports = __webpack_public_path__ + "img/account-pro_gold.35b68981.svg";